module.exports = __webpack_public_path__ + "img/progress_041.830746e8.png";